import { formatRelative } from 'date-fns';

import Text from '@cartwhl/ui/base/Text';

export default function UploadSuccess({
  characterName,
  createdAt,
  title = 'Character Upload',
}: {
  characterName: string;
  createdAt: string;
  title?: string;
}) {
  const dateParts = formatRelative(createdAt, new Date()).split(' at ');
  return (
    <>
      <div className="bg-gray-15 dark:bg-gray-75 rounded-2xl p-4">
        <div className="flex justify-between">
          <div className="flex gap-3">
            <svg
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M9.9917 18.5815C8.81852 18.5815 7.71452 18.3574 6.67969 17.9092C5.64486 17.4665 4.73177 16.8494 3.94043 16.0581C3.15462 15.2668 2.5376 14.3537 2.08936 13.3188C1.64111 12.284 1.41699 11.18 1.41699 10.0068C1.41699 8.83366 1.64111 7.72965 2.08936 6.69482C2.5376 5.65999 3.15462 4.74967 3.94043 3.96387C4.73177 3.17253 5.64209 2.55273 6.67139 2.10449C7.70622 1.65625 8.81022 1.43213 9.9834 1.43213C11.1621 1.43213 12.2689 1.65625 13.3037 2.10449C14.3385 2.55273 15.2516 3.17253 16.043 3.96387C16.8343 4.74967 17.4541 5.65999 17.9023 6.69482C18.3506 7.72965 18.5747 8.83366 18.5747 10.0068C18.5747 11.18 18.3506 12.284 17.9023 13.3188C17.4541 14.3537 16.8343 15.2668 16.043 16.0581C15.2516 16.8494 14.3385 17.4665 13.3037 17.9092C12.2689 18.3574 11.1649 18.5815 9.9917 18.5815ZM9.9917 16.8882C10.9491 16.8882 11.8428 16.7111 12.6729 16.3569C13.5085 16.0028 14.2389 15.5103 14.8643 14.8794C15.4951 14.2485 15.9876 13.5181 16.3418 12.688C16.696 11.8579 16.873 10.9642 16.873 10.0068C16.873 9.05501 16.696 8.16406 16.3418 7.33398C15.9876 6.49837 15.4924 5.76514 14.856 5.13428C14.2251 4.50342 13.4946 4.0109 12.6646 3.65674C11.8345 3.30257 10.9408 3.12549 9.9834 3.12549C9.03158 3.12549 8.13786 3.30257 7.30225 3.65674C6.47217 4.0109 5.74447 4.50342 5.11914 5.13428C4.49382 5.76514 4.00407 6.49837 3.6499 7.33398C3.29574 8.16406 3.11865 9.05501 3.11865 10.0068C3.11865 10.9642 3.29574 11.8579 3.6499 12.688C4.00407 13.5181 4.49382 14.2485 5.11914 14.8794C5.75 15.5103 6.48047 16.0028 7.31055 16.3569C8.14616 16.7111 9.03988 16.8882 9.9917 16.8882ZM9.09521 13.9497C8.94027 13.9497 8.80192 13.9165 8.68018 13.8501C8.55843 13.7782 8.43945 13.673 8.32324 13.5347L6.36426 11.144C6.22038 10.9614 6.14844 10.776 6.14844 10.5879C6.14844 10.3831 6.21761 10.2088 6.35596 10.0649C6.49984 9.91553 6.67139 9.84082 6.87061 9.84082C6.99788 9.84082 7.11133 9.86849 7.21094 9.92383C7.31608 9.97363 7.41846 10.0649 7.51807 10.1978L9.06201 12.1567L12.3408 6.90234C12.5124 6.62012 12.7282 6.479 12.9883 6.479C13.182 6.479 13.3563 6.54264 13.5112 6.66992C13.6662 6.7972 13.7437 6.96322 13.7437 7.16797C13.7437 7.26204 13.7215 7.35889 13.6772 7.4585C13.6385 7.55257 13.5915 7.64111 13.5361 7.72412L9.82568 13.5264C9.6486 13.8086 9.40511 13.9497 9.09521 13.9497Z"
                fill="#0FD23A"
              />
            </svg>

            <div>
              <Text as="p" variant="studio/body/medium/md">
                {title}
              </Text>
              <Text
                variant="studio/body/medium/md"
                className="text-gray-60 dark:text-gray-45 overflow-hidden  break-words transition-colors"
              >
                {characterName}
              </Text>
            </div>
          </div>
          <div>
            <Text
              variant="studio/body/medium/md"
              className="text-gray-60 dark:text-gray-45 text-right"
              as="div"
            >
              {dateParts[0]}
            </Text>
            {dateParts[1] && (
              <Text
                variant="studio/body/medium/md"
                className="text-gray-60 dark:text-gray-45 text-right"
                as="div"
              >
                {dateParts[1].replace(' ', '').toLowerCase()}
              </Text>
            )}
          </div>
        </div>
      </div>
    </>
  );
}
